const UNAVAILABLE_NETWORK_CODES = new Set([
  'ECONNREFUSED',
  'ERR_NETWORK',
  'ERR_CONNECTION_REFUSED',
  'ECONNABORTED',
]);

function titleCase(value) {
  return String(value || '')
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

function compact(value) {
  if (value === null || value === undefined) return '';
  return String(value).trim();
}

export function formatStaffAlertEventType(eventType) {
  return titleCase(eventType) || 'Staff Alert';
}

export function getStaffAlertDedupeKey(alert = {}) {
  const context = alert.context || {};
  const entityId =
    context.lead_id ||
    context.chat_session_id ||
    context.guest_preference_submission_id ||
    alert.alert_id ||
    alert.id ||
    'unknown';

  return `${alert.event_type || 'staff_alert'}:${entityId}`;
}

export function getSafeStaffAlertUrl(url) {
  const rawUrl = compact(url);
  if (!rawUrl) return null;

  const lowerUrl = rawUrl.toLowerCase();
  if (
    lowerUrl.startsWith('http://') ||
    lowerUrl.startsWith('https://') ||
    lowerUrl.startsWith('//') ||
    lowerUrl.startsWith('javascript:') ||
    lowerUrl.startsWith('data:')
  ) {
    return null;
  }

  return rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`;
}

export function getStaffAlertCtaLabel(alert = {}) {
  const eventType = String(alert.event_type || '').toLowerCase();
  const context = alert.context || {};

  if (context.lead_id || eventType.includes('lead')) return 'Open Lead';
  if (context.chat_session_id || eventType.includes('chat')) return 'Open Chat';
  if (context.guest_preference_submission_id || eventType.includes('guest_preference')) {
    return 'Open Sheet';
  }
  return 'Open';
}

export function getStaffAlertContextChips(alert = {}) {
  const context = alert.context || {};
  const chips = [];

  if (alert.priority && String(alert.priority).toLowerCase() !== 'normal') {
    chips.push(titleCase(alert.priority));
  }
  if (context.lead_id) chips.push(`Lead #${context.lead_id}`);
  if (context.chat_session_id) chips.push(`Chat ${context.chat_session_id}`);
  if (context.guest_preference_submission_id) {
    chips.push(`Sheet #${context.guest_preference_submission_id}`);
  }
  if (context.guest_name) chips.push(String(context.guest_name));
  if (context.villa_name) chips.push(String(context.villa_name));
  if (context.source) chips.push(titleCase(context.source));

  return chips.filter(Boolean).slice(0, 6);
}

export function isStaffAlertEndpointUnavailable(error) {
  const status = error?.response?.status;
  if (status === 404 || status >= 500) return true;
  if (UNAVAILABLE_NETWORK_CODES.has(error?.code)) return true;

  const message = String(error?.message || '').toLowerCase();
  return message.includes('network error') || message.includes('connection refused');
}
